module.exports = __webpack_public_path__ + "static/media/branding-img4.27f325ad.jpg";